const recommendedObserver = new MutationObserver((mutationRecords) => {
  if (mutationRecords[0].target === document.getElementsByClassName('related-products')[0]) {
    getVariantColors();
    addSliderDots();
    addSliderEvents();
    addsliderButtonEvents();
  }
});

// Select the element you want to watch
const recommendedGrid = document.getElementById('MainContent');

// Call the observe function by passing the node you want to watch with configuration options
recommendedObserver.observe(recommendedGrid, {
  attributes: true,
  childList: true,
  subtree: true,
  characterData: false,
  characterDataOldValue: false,
});

const addSliderDots = () => {
  const amountShown = window.innerWidth > 768 ? 4 : 2;
  const products = document.getElementsByClassName('product-grid')[0].children;
  const productsArray = Array.from(products);
  const sliderDotsWrapper = document.getElementById('recomended-slider-dots');
  productsArray.forEach((product, index) => {
    if (index % amountShown === 0) {
      const sliderDot = document.createElement('div');
      sliderDot.classList.add('recomended-slider-dot');
      if (index === 0) {
        sliderDot.classList.add('active');
      }
      sliderDot.setAttribute('data-index', index);
      sliderDotsWrapper.appendChild(sliderDot);
    }
  });
};

const addSliderEvents = () => {
  const grid = document.getElementsByClassName('product-grid')[0];
  const slides = grid.children;
  const slidesArray = Array.from(slides);
  grid.addEventListener('scroll', (e) => {
    slideFunction(slidesArray);
  });
  slidesArray.forEach((slide) => {
    slide.addEventListener('touchend', (e) => {
      slideFunction(slidesArray);
    });
  });
};

const slideFunction = (slidesArray) => {
  setTimeout(() => {
    const mostLeftVisibleIndex = slidesArray.reduce((acc, currentSlide, index) => {
      const { left } = currentSlide.getBoundingClientRect();

      if (left < 100) {
        return index;
      }
      return acc;
    }, 0);
    const sliderDots = document.querySelectorAll('#recomended-slider-dots .recomended-slider-dot');
    const sliderDotsArray = Array.from(sliderDots);
    const activeSliderDotIndex = sliderDotsArray.findIndex(
      (dot) => dot.getAttribute('data-index') == mostLeftVisibleIndex,
    );
    if (activeSliderDotIndex !== -1) {
      sliderDotsArray.forEach((dot, index) => {
        if (index === activeSliderDotIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  }, 300);
};

const addsliderButtonEvents = () => {
  const relatedProductPrevButton = document.getElementById('related-product-slider-prev');
  const relatedProductNextButton = document.getElementById('related-product-slider-next');

  const relatedProductSlider = document.getElementsByClassName('product-grid')[0];
  const slidesWidth = document.getElementsByClassName('grid__item')[0].offsetWidth;

  relatedProductPrevButton.addEventListener('click', () => {
    relatedProductSlider.scrollBy({
      left: -slidesWidth,
      behavior: 'smooth',
    });
  });
  relatedProductNextButton.addEventListener('click', () => {
    relatedProductSlider.scrollBy({
      left: slidesWidth,
      behavior: 'smooth',
    });
  });
};
